import React from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';

import Spinner from '@stubhub/react-spinner';

const Comp = Loadable({
  loader: /* istanbul ignore next */ () =>
    import(/* webpackChunkName: "swi-virtual-assistant" */ '@stubhub/react-virtual-assistant'),
  loading: Spinner,
});

const VirtualAssistantLazyLoad = (props, {globalRegistry}) => {
  const locale = globalRegistry.getCurrentLocale();
  const mergedProps = {locale, ...props};

  return (
    <div className="virtual-assistant-container">
      <Comp {...mergedProps} />
    </div>
  );
};

VirtualAssistantLazyLoad.contextTypes = {
  globalRegistry: PropTypes.object,
};

export default VirtualAssistantLazyLoad;
